const firebase = require("firebase/app");
require("firebase/database");
require("firebase/storage");

export const like = (id, likes, liked) => {
  let new_likes = [];
  let to_add = true;

  likes.forEach((e) => {
    if (e != id) {
      new_likes.push(e);
    }
    if (e == id) {
      to_add = false;
    }
  });

  if (to_add) {
    new_likes.push(id);
    liked();
  }

  var likesRef = firebase
    .database()
    .ref("likes/" + firebase.auth().currentUser.uid);
  likesRef.update({
    user_likes: new_likes,
  });
};
